import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { configuracion } from 'src/app/recursos/config.service';
import { ToolsService } from 'src/app/recursos/tools.service';
import { LoaderComponent } from 'src/app/servicios/loader/loader.component';
import { SeleccionService } from 'src/app/servicios/seleccion.service';

@Component({
  selector: 'app-encuesta-lista-faltantes',
  templateUrl: './encuesta-lista-faltantes.component.html',
  styleUrls: ['./encuesta-lista-faltantes.component.css']
})
export class EncuestaListaFaltantesComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtOptionsFicha: DataTables.Settings = {};
  public dtTriggerFicha: Subject<any>;

  public encabezado: string = ""; public nombreBeca: string = ""; public selectPeriodo: string = ''; public selectFacultad: string = ''; public selectCarrera: string = '';
  public vecListaResponde = []; public vecPeriodo = []; public vecFacultad = []; public vecCarrera = [];

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService, private confMensaje: configuracion,
    private modalService: NgbModal, private alerti: AlertifyService, private ruta: Router) { }

  ngOnInit() {
    this.dtTriggerFicha = new Subject<any>();
    this.dtOptionsFicha[0] = this.tools.OpcionesTabla(10);

    this.encabezado = "Lista de estudiantes";
    this.nombreBeca = localStorage.getItem('modNom');
    this.cargarPeriodos();
  }
  //FUNCION QUE CARGA TODAS LOS PERIODOS ACADEMICOS DE LA INSTITUCION
  async cargarPeriodos() {
    this.vecPeriodo = [];
    //OBTENER TODOS LOS PERIODOS ACADÉMICOS
    const resPeriodo = await new Promise<any>(resolve => this.srvSelect.gestionCarreras(3, 'na', 'na', 'na').subscribe(translated => { resolve(translated) }));
    if (resPeriodo.success) {
      this.selectPeriodo = resPeriodo.carrera[0]['strCodigo'];
      this.vecPeriodo = resPeriodo.carrera
    }
    //OBTENER TODAS LAS FACULTADES
    const resFacultad = await new Promise<any>(resolve => this.srvSelect.gestionCarreras(1, 'na', 'na', 'na').subscribe(translated => { resolve(translated) }));
    if (resFacultad.success)
      this.vecFacultad = resFacultad.carrera;
  }
  //VER LAS CARRERAS QUE CORRESPONDEN A UNA FACULTAD DADA
  async verCarreras() {
    //OBTENER TODAS LAS FACULTADES
    const resCarrera = await new Promise<any>(resolve => this.srvSelect.gestionCarreras(2, this.selectFacultad, 'na', 'na').subscribe(translated => { resolve(translated) }));
    if (resCarrera.success)
      this.vecCarrera = resCarrera.carrera;
  }
  //ABRIR EL MODAL PARA ESCOGER EL PERIODO DE DE CONSULTA
  verFechasRespuesta(nameMod) {
    if (localStorage.getItem('modUser') == 'true') {
      this.mr = this.modalService.open(nameMod);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //BUSCAR LAS FICHAS RESPONDIDAS EN EL PERIODO ACADEMICO
  async verResultados() {
    this.vecListaResponde = []; let banRes = 0;
    if (this.selectCarrera) {
      var table2 = $('#tblFichas').DataTable({ destroy: true });
      table2.destroy();
      this.cerrarModal();
      this.cargando.abrir();
      this.vecListaResponde = [];

      const resCarrera = await new Promise<any>(resolve => this.srvSelect.gestionCarreras(11, this.selectCarrera, 'na', 'na').subscribe(translated => { resolve(translated) }));
      if (resCarrera.success) {
        for (let objCar of resCarrera.carrera) {
          //OBTENER LOS ESTUDIANTES MATRICULADOS DE CADA CARRERA
          const resMatr = await new Promise<any>(resolve => this.srvSelect.gestionMatricula(4, objCar.carBase, this.selectPeriodo, 'na', 'na').subscribe(translated => { resolve(translated) }));
          const resResCuest = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(17, objCar.carCod, '2', this.selectPeriodo, 'na').subscribe(translated => { resolve(translated) }));

          if (resMatr.success) {
            for (let objMatr of resMatr.matricula) {
              banRes = 0;
              if (resResCuest.resultado) {

                if (resResCuest.fichaEstudiantil.filter(objRes => objRes.strCedEstudiante.replace('-', '') == objMatr.strCedula.replace('-', '')).length > 0) {
                  banRes = (resResCuest.fichaEstudiantil.filter(objRes => objRes.strCedEstudiante.replace('-', '') == objMatr.strCedula.replace('-', ''))[0].intEstado);

                  this.cargarRespuesta(objMatr.strCedula, objMatr.strCodigo, objMatr.strNombres, objMatr.strApellidos, objMatr.strCodSexo, objCar.carNomb,
                    objCar.FacNomb, objMatr.strCodEstado, objMatr.strCodNivel, objMatr.strCodPensum, objMatr.strCodPeriodo, objMatr.strEmail, objMatr.strNacionalidad,
                    banRes, banRes == 0 ? 'No Llena' : banRes == 1 ? 'Completada' : 'En Proceso');
                }
                else
                  this.cargarRespuesta(objMatr.strCedula, objMatr.strCodigo, objMatr.strNombres, objMatr.strApellidos, objMatr.strCodSexo, objCar.carNomb,
                    objCar.FacNomb, objMatr.strCodEstado, objMatr.strCodNivel, objMatr.strCodPensum, objMatr.strCodPeriodo, objMatr.strEmail, objMatr.strNacionalidad,
                    banRes, 'No Llena');
              }
              else
                this.cargarRespuesta(objMatr.strCedula, objMatr.strCodigo, objMatr.strNombres, objMatr.strApellidos, objMatr.strCodSexo, objCar.carNomb,
                  objCar.FacNomb, objMatr.strCodEstado, objMatr.strCodNivel, objMatr.strCodPensum, objMatr.strCodPeriodo, objMatr.strEmail, objMatr.strNacionalidad,
                  banRes, 'No Llena');
            }
          }
        } this.dtTriggerFicha.next();
      }
      else
        this.alerti.message('No se encntró información de encuestas registradas');

      this.cargando.cerrar();
    }
    this.alerti.message('Seleccione una carrera');
  }
  
  //BUSCAR LAS FICHAS RESPONDIDAS EN EL PERIODO ACADEMICO
  async verResultados1() {
    this.vecListaResponde = []; let banRes = 0;
    if (this.selectCarrera) {
      var table2 = $('#tblFichas').DataTable({ destroy: true });
      table2.destroy();
      this.cerrarModal();
      this.cargando.abrir();
      this.vecListaResponde = [];

      const resCarrera = await new Promise<any>(resolve => this.srvSelect.gestionCarreras(12, 'this.selectCarrera', 'na', 'na').subscribe(translated => { resolve(translated) }));
      if (resCarrera.success) {
        for (let objCar of resCarrera.carrera) {
          //OBTENER LOS ESTUDIANTES MATRICULADOS DE CADA CARRERA
          const resMatr = await new Promise<any>(resolve => this.srvSelect.gestionMatricula(4, objCar.carBase, this.selectPeriodo, 'na', 'na').subscribe(translated => { resolve(translated) }));
          const resResCuest = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(17, objCar.carCod, '2', this.selectPeriodo, 'na').subscribe(translated => { resolve(translated) }));

          if (resMatr.success) {
            for (let objMatr of resMatr.matricula) {
              banRes = 0;
              if (resResCuest.resultado) {

                if (resResCuest.fichaEstudiantil.filter(objRes => objRes.strCedEstudiante.replace('-', '') == objMatr.strCedula.replace('-', '')).length > 0) {
                  banRes = (resResCuest.fichaEstudiantil.filter(objRes => objRes.strCedEstudiante.replace('-', '') == objMatr.strCedula.replace('-', ''))[0].intEstado);

                  this.cargarRespuesta(objMatr.strCedula, objMatr.strCodigo, objMatr.strNombres, objMatr.strApellidos, objMatr.strCodSexo, objCar.carNombre,
                    objCar.facNombre, objMatr.strCodEstado, objMatr.strCodNivel, objMatr.strCodPensum, objMatr.strCodPeriodo, objMatr.strEmail, objMatr.strNacionalidad,
                    banRes, banRes == 0 ? 'No Llena' : banRes == 1 ? 'Completada' : 'En Proceso');
                }
                else
                  this.cargarRespuesta(objMatr.strCedula, objMatr.strCodigo, objMatr.strNombres, objMatr.strApellidos, objMatr.strCodSexo, objCar.carNombre,
                    objCar.facNombre, objMatr.strCodEstado, objMatr.strCodNivel, objMatr.strCodPensum, objMatr.strCodPeriodo, objMatr.strEmail, objMatr.strNacionalidad,
                    banRes, 'No Llena');
              }
              else
                this.cargarRespuesta(objMatr.strCedula, objMatr.strCodigo, objMatr.strNombres, objMatr.strApellidos, objMatr.strCodSexo, objCar.carNombre,
                  objCar.facNombre, objMatr.strCodEstado, objMatr.strCodNivel, objMatr.strCodPensum, objMatr.strCodPeriodo, objMatr.strEmail, objMatr.strNacionalidad,
                  banRes, 'No Llena');
            }
          }
        } this.dtTriggerFicha.next();
      }
      else
        this.alerti.message('No se encntró información de encuestas registradas');

      this.cargando.cerrar();
    }
    this.alerti.message('Seleccione una carrera');
  }

  cargarRespuesta(dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, dato9, dato10, dato11, dato12, dato13, dato14, dato15) {
    this.vecListaResponde.push({
      strCedula: dato1, strCodigo: dato2, strNombres: dato3, strApellidos: dato4, strCodSexo: dato5, strCarrera: dato6, strFacultad: dato7, strCodEstado: dato8,
      strCodNivel: dato9, strCodPensum: dato10, strCodPeriodo: dato11, strEmail: dato12, strNacionalidad: dato13, estFicha: dato14, detEstFicha: dato15
    })
  }
  //FUNCION QUE ABRA LAS RESPUESTAS DE UNA FICHA SELECCIONADA
  verRespuesta(objFicha) {
    localStorage.setItem('localVerResp', objFicha.strIdResponde);
    this.ruta.navigate(["/gestion/verRespuestaFicha"]);
  }
  //FUNCION PARA CERRAR UN MODAL
  cerrarModal() {
    this.mr.close();
  }
}
